<ng-container *ngIf="withFlag">
  <span id="alert-flag" class="alert-flag alert-flag--{{ type }}">
    <nibtravel-icon
      id="alert-icon"
      class="alert-icon"
      size="sm"
      icon="{{ iconType }}"
    ></nibtravel-icon>
  </span>
</ng-container>
<span id="alert-info" class="alert-info">
  <h5 id="alert-info-title" class="alert-info-title" *ngIf="title">
    {{ title }}
  </h5>
  <ng-content></ng-content>
  <ngx-contentful-rich-text
    [document]="richText"
    [nodeRenderers]="nodeRenderers"
    *ngIf="richText"
  ></ngx-contentful-rich-text>
</span>
<ng-container *ngIf="canBeClosed">
  <span class="alert-close">
    <nibtravel-icon
      tabindex="0"
      size="lg"
      icon="close"
      (click)="close()"
    ></nibtravel-icon>
  </span>
</ng-container>
